import { lazy } from "react";

export default lazy(async () => {
  return import(
    /* webpackChunkName: "Authentication" */
    "./Authentication.container"
  );
});
